import { ACCEPT, ERROR_FETCH_TOS, START_FETCH_TOS, SUCCESS_FETCH_TOS } from './actionTypes';
import * as termsOfServiceAPI from 'login-apis/termsOfServiceAPI';
import { createAction } from 'redux-actions';

const startGetTerms = createAction(START_FETCH_TOS);
const getTermsSuccess = createAction(SUCCESS_FETCH_TOS, content => content);
const getTermsError = createAction(ERROR_FETCH_TOS, () => 'Error fetching Terms of Use.');

export function getTermsText() {
  return async function(dispatch) {
    dispatch(startGetTerms());
    try {
      const res: any = await termsOfServiceAPI.getTerms();
      dispatch(getTermsSuccess(res.data.htmlText as string));
    } catch (err) {
      dispatch(getTermsError());
    }
  };
}

export const acceptTerms = createAction(ACCEPT);
